var App = App || {};

App.ScrollAnimate = (function ($) {

    'use strict';

    function ScrollAnimate() {

     //hp banner
        const hpBanner = $(".widget-homepage-banner");
        const hpBannerOffset = 75;
        const hpBannerTargets = [
            { selector: ".widget-homepage-banner-image", type: "animate__fadeIn", stagger: 0 },
            { selector: ".widget-homepage-banner-content > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const hpBannerOverflow = false;

        hpBanner.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: hpBannerOffset,
            targets: hpBannerTargets,
            overflow: hpBannerOverflow
        });

        //masthead
        const masthead = $(".widget-masthead");
        const mastheadOffset = 75;
        const mastheadTargets = [
            { selector: ".widget-masthead-image", type: "animate__fadeInUp", stagger: 0 },
            { selector: ".widget-masthead-content > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const mastheadOverflow = false;

        masthead.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: mastheadOffset,
            targets: mastheadTargets,
            overflow: mastheadOverflow
        });

        //content cards
        const contentCards = $(".widget-content-cards");
        const contentCardsOffset = 75;
        const contentCardsTargets = [
            { selector: ".widget-content-cards-layout.magazine > * > *", type: "animate__fadeInUp", stagger: 0 },
            { selector: ".widget-content-cards-layout > *", type: "animate__fadeInUp", stagger: 400 }

        ]
        const contentCardsOverflow = false;

        contentCards.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: contentCardsOffset,
            targets: contentCardsTargets,
            overflow: contentCardsOverflow
        });

        //features
        const features = $(".widget-features-band");
        const featuresOffset = 75;
        const featuresTargets = [
            { selector: ".widget-features-band__caption > *", type: "animate__fadeInUp", stagger: 400 },
            { selector: ".features-band-items > *", type: "animate__fadeInUp", stagger: 400 }

        ]
        const featuresOverflow = false;

        features.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: featuresOffset,
            targets: featuresTargets,
            overflow: featuresOverflow
        });


        //rates band
        const ratesPromos = $(".widget-rate-promos-band");
        const ratesPromosOffset = 75;
        const ratesPromosTargets = [
            { selector: ".widget-rate-promo-list > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const ratesPromosOverflow = false;

        ratesPromos.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: ratesPromosOffset,
            targets: ratesPromosTargets,
            overflow: ratesPromosOverflow
        });

        //testimonials
        const testimonial = $(".widget.testimonials");
        const testimonialOffset = 75;
        const testimonialTargets = [
            { selector: ".item-testimonial > *", type: "animate__fadeIn", stagger: 400 }

        ]
        const testimonialOverflow = false;

        testimonial.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: testimonialOffset,
            targets: testimonialTargets,
            overflow: testimonialOverflow
        });

        //resources band
        const resourcesBand = $(".widget-resources-band");
        const resourcesBandOffset = 75;
        const resourcesBandTargets = [
            { selector: ".widget-resources-band-items > *", type: "animate__fadeInUp", stagger: 400 },
            { selector: ".widget-structure-ctas > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const resourcesBandOverflow = false;

        resourcesBand.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: resourcesBandOffset,
            targets: resourcesBandTargets,
            overflow: resourcesBandOverflow
        });

        //structure
        const structure = $(".widget-structure");
        const structureOffset = 75;
        const structureTargets = [
            { selector: ".widget-structure-layout > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const structureOverflow = true;

        structure.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: structureOffset,
            targets: structureTargets,
            overflow: structureOverflow
        });


        //blogPost
        const blogPost = $(".blog-list");
        const blogPostOffset = 75;
        const blogPostTargets = [
            { selector: ".blog-list-items > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const blogPostOverflow = false;

        blogPost.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: blogPostOffset,
            targets: blogPostTargets,
            overflow: blogPostOverflow
        });



        //mediaCenter
        const mediaCenter = $(".widget-media-center");
        const mediaCenterOffset = 75;
        const mediaCenterTargets = [
            { selector: ".widget-media-center-layout > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const mediaCenterOverflow = false;

        mediaCenter.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: mediaCenterOffset,
            targets: mediaCenterTargets,
            overflow: mediaCenterOverflow
        });



        //bioslist
        const biosList = $(".widget-bios");
        const biosListOffset = 75;
        const biosListTargets = [
            { selector: ".widget-bios-items > *", type: "animate__fadeInUp", stagger: 400 }
        ]
        const biosListOverflow = false;

        biosList.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: biosListOffset,
            targets: biosListTargets,
            overflow: biosListOverflow
        });

        //promos
        const promos = $(".section");
        const promosOffset = 75;
        const promosTargets = [
            { selector: ".widget-promos", type: "animate__fadeInUp", stagger: 400 }
        ]
        const promosOverflow = false;

        promos.ZagScrollAnimate({
            // normally values can be placed right in the plugin init; use of variables is just to better explain the plugin
            offset: promosOffset,
            targets: promosTargets,
            overflow: promosOverflow
        });
    }

    return {
        ScrollAnimate: ScrollAnimate
    };

})(jQuery);
